import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import logoHeader from "../../../assets/fluxmed-logo-horizontal.png";
import { ContentBoxTitle } from "../../../components/common";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { endpoints } from "@/configs/Settings";

interface RegistrationSuccessProps {
  displayName: string;
  /**
   * `organization`: cópia voltada ao cadastro de clínica/empresa (CNPJ).
   * Omitido ou `cpf`: fluxo pessoa física (comportamento original).
   */
  variant?: "cpf" | "organization";
}

export function RegistrationSuccess({
  displayName,
  variant = "cpf",
}: RegistrationSuccessProps) {
  // Função para navegar para a página inicial
  const handleOpenPortal = () => {
    window.open(endpoints.XDSB_domain, "_blank");
  };

  return (
    <Stack alignItems="center" spacing={8}>
      <Stack alignItems="center" spacing={2}>
        <img src={logoHeader} alt="Logo fluxmed" width={185} height="auto" />
        <ContentBoxTitle>Cadastro Realizado com Sucesso!</ContentBoxTitle>
      </Stack>

      <Stack
        spacing={6}
        justifyContent="center"
        alignItems="center"
        sx={{ maxWidth: "600px" }}
      >
        <CheckCircleIcon
          sx={{
            color: "success.main",
            fontSize: 80,
            mb: 2,
          }}
        />

        <Typography variant="h6" align="center" fontWeight="500">
          Parabéns, {displayName}! Seu cadastro foi concluído com sucesso.
        </Typography>

        <Typography variant="body1" align="center">
          {variant === "organization" ? (
            <>
              Agora você pode acessar os recursos da plataforma Fluxmed para a
              sua organização. Explore as funcionalidades e serviços
              disponíveis.
            </>
          ) : (
            <>
              Agora você pode acessar todos os recursos disponíveis para
              usuários pessoa física na plataforma Fluxmed. Aproveite para
              explorar as funcionalidades e serviços disponíveis.
            </>
          )}
        </Typography>

        <Typography variant="body1" align="center">
          Para começar a utilizar o sistema, clique no botão abaixo.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleOpenPortal}
          sx={{
            padding: "16px 32px",
            borderRadius: "8px",
            fontSize: "1rem",
            textTransform: "none",
            minWidth: "220px",
            mt: 2,
          }}
        >
          Ir para a Página Inicial
        </Button>
      </Stack>
    </Stack>
  );
}
